module.exports = __webpack_public_path__ + "assets/images/fda23f46cf37b6d8cebd191ff306d089.jpg";